const aplicacoes = [
  { icon: 'ri-group-line', nome: 'Sala de reunião' },
  { icon: 'ri-vip-crown-line', nome: 'Diretoria' },
  { icon: 'ri-user-heart-line', nome: 'RH' },
  { icon: 'ri-money-dollar-circle-line', nome: 'Financeiro' },
  { icon: 'ri-stethoscope-line', nome: 'Consultórios' },
  { icon: 'ri-lock-line', nome: 'Salas privativas' },
  { icon: 'ri-layout-grid-line', nome: 'Open office' },
  { icon: 'ri-home-heart-line', nome: 'Recepção' },
  { icon: 'ri-arrow-left-right-line', nome: 'Corredores' },
  { icon: 'ri-briefcase-line', nome: 'Áreas administrativas' },
];

export default function AplicacoesSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-12">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Aplicações
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            Onde as divisórias corporativas fazem diferença.
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {aplicacoes.map((a) => (
            <div
              key={a.nome}
              className="group flex flex-col items-center justify-center text-center rounded-2xl bg-white border border-background-200/60 px-4 py-8 transition-colors hover:border-primary-200"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 mb-4 group-hover:bg-primary-50 group-hover:text-primary-600 transition-colors">
                <i className={`${a.icon} text-2xl`}></i>
              </span>
              <span className="text-foreground-800 text-[14px] font-medium">{a.nome}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}